var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfittedbottomsheetnopillow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102.63pt",
    height: "51.345pt",
    viewBox: "0 0 102.63 51.345",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-613.38 -54.038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m661.63 104.52 51.77-24.586c1.6602-0.75781 2.2773-1.5625 2.3594-2.1562v-8.7109c8e-3 -1.2148-1.957-2.0078-1.957-2.0078l-39.055-12.293c-2.9727-1.0625-5.3672-0.02734-5.3672-0.02734l-53.312 20.723s-2.4531 1.0078-2.4102 2.4648v9.5156c0.0781 0.73047 0.83203 1.5742 2.9062 2.4688l38.926 14.785-8e-3 0.0117s3.2852 1.1172 6.3672-0.28906",
    fill: "#ddd9cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613.41 77.93v9.5156h0.25l-0.0391-0.24609-0.23828 0.03516 0.0273 0.23828c0.0469 0.44141 0.30078 0.89062 0.78516 1.332 0.49219 0.44141 1.2188 0.88281 2.2734 1.3398h4e-3l38.93 14.789 0.0859-0.23438-0.22656-0.10156-4e-3 0.0117-0.10938 0.25 0.25781 0.0859c0.0156 4e-3 1.2734 0.4375 2.9844 0.4375 1.0742 0 2.332-0.17187 3.5664-0.73437l-0.21094-0.45703c-1.1484 0.52734-2.332 0.69141-3.3555 0.69141-0.81641 0-1.5234-0.10547-2.0273-0.20703-0.25391-0.0508-0.45312-0.10156-0.58984-0.14062-0.13672-0.0391-0.20703-0.0625-0.20703-0.0625l-0.082 0.23828 0.23047 0.0977 4e-3 -8e-3 0.10547-0.24219-39.168-14.879-0.0898 0.23437 0.10156-0.23047c-1.0234-0.4375-1.707-0.86328-2.1367-1.25-0.42578-0.39062-0.59375-0.72656-0.625-1.0156l-0.24609 0.02734 0.0352 0.25h4e-3l0.21094-0.03516v-9.7305",
    fill: "#6b645b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613.9 77.902-4e-3 -0.10547c0-0.27344 0.11719-0.53906 0.32422-0.79688 0.30469-0.38281 0.79297-0.71875 1.2031-0.94922 0.20312-0.11328 0.38672-0.20312 0.51953-0.26562 0.13281-0.05859 0.21094-0.08984 0.21094-0.08984l53.316-20.719 8e-3 -0.0039 0.0391-0.01563c0.19922-0.07813 1.1445-0.41797 2.4766-0.41797 0.77734 0 1.6914 0.11719 2.668 0.46484l4e-3 0.0039 39.059 12.293 0.0742-0.23828-0.0859 0.23438 0.0742 0.03125c0.17969 0.07031 0.63281 0.27734 1.0273 0.57031 0.40234 0.29687 0.70703 0.67187 0.69922 1.0391l-8e-3 0.09766 0.49609 0.06641 0.0117-0.16406c0-0.36328-0.15625-0.67578-0.36328-0.93359-0.625-0.76562-1.75-1.1641-1.7656-1.1758h-4e-3l-39.059-12.297-0.0781 0.23828 0.0859-0.23828c-1.0391-0.36719-2.0078-0.49219-2.8359-0.49219-1.6172 0-2.6953 0.46484-2.7148 0.47266l0.0977 0.23047-0.0898-0.23047-53.312 20.719c-0.0117 0.0039-0.62891 0.24219-1.2578 0.67188-0.31641 0.21094-0.63672 0.47266-0.88672 0.78516s-0.43359 0.6875-0.43359 1.1094l8e-3 0.16406",
    fill: "#6b645b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m715.76 69.637v-0.56641l0.0586 0.0078 0.13672 0.01953c-0.0234 0.17969-0.0898 0.35938-0.19531 0.53906",
    fill: "#dad6d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m658.54 95.625c-1.7344 0-3.0234-0.52734-3.1289-0.57422l-38.922-14.465-4e-3 -0.0039c-1.0508-0.45312-1.7734-0.89453-2.2578-1.3281-0.12109-0.11328-0.23047-0.22266-0.32031-0.33203v-0.78125c0.082 0.24609 0.26172 0.51562 0.58984 0.8125 0.43359 0.39453 1.1211 0.82031 2.1406 1.2617l38.918 14.465h8e-3s0.0742 0.03516 0.21484 0.08594c0.14453 0.05078 0.35938 0.11719 0.625 0.1875 0.53125 0.13672 1.2812 0.27344 2.1367 0.27344 0.91797 0 1.957-0.15625 3.0039-0.63281l51.773-23.656c1.6445-0.75 2.1914-1.4258 2.2422-1.8945l0.19922 0.02734v0.57031c-0.31641 0.53906-1.0195 1.082-2.2773 1.6602l-51.773 23.656c-1.1055 0.50391-2.2031 0.66797-3.168 0.66797m-44.684-17.695h-0.19922l0.19922-0.01953v0.01953",
    fill: "#c2bbb0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613.91 78.922c-0.26953-0.32812-0.41406-0.65234-0.44922-0.96875l0.19922-0.02344h0.19922c0.0117 0.07031 0.0273 0.14062 0.0508 0.21094",
    fill: "#6b645b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613.66 77.93 0.19922-0.01953-0.19922 0.01953m102.16-8.8516-0.0586-0.0078-0.19922-0.02734",
    fill: "#6b645b"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-613.38 -54.038)",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m7157.5 5265.2v-89.844c-0.7813-5.9375-6.9531-13.984-23.555-21.562l-517.7-245.86",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m6138 5076.1 17.617 17.656"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m6137.8 5075.7 16.328 3.5156"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m6137.9 5074 31.367-9.8828"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m7156.2 5173.3-17.617 17.617"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m7156.5 5172.9-16.289 3.5156"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m7156.3 5171.2-31.328-9.9219"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m6581.9 4902.2 16.016 21.016"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m6580.8 4902.2 5.5469 27.656"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m6579.1 4902.2-2.0312 17.461"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m6579.1 4902.2-14.375 20.469"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m6582.5 4902.2 12.148 7.1875"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfittedbottomsheetnopillow);
export default __webpack_public_path__ + "static/media/afittedbottomsheetnopillow.32c32299f85180a1469571e9f0021bf3.svg";
export { ForwardRef as ReactComponent };